import type {ReactElement} from 'react';
import {useRef} from 'react';
import {Text, TextSize} from '@Components/text';
import {useIsElementContentClamped} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-multiposting.hooks';
import type {VerticalVideoCaptionLineProps} from './vertical-video-caption-line.types';
import styles from './vertical-video-caption-line.module.scss';

export function VerticalVideoCaptionLine({caption, moreClassName}: VerticalVideoCaptionLineProps): ReactElement | null {
  const captionTextRef = useRef<HTMLSpanElement>(null);
  const isCaptionTruncated = useIsElementContentClamped(captionTextRef, caption);

  const getCaptionText = (): ReactElement => {
    return <Text className={styles.verticalVideoCaptionText} ref={captionTextRef} size={TextSize.XS} val={caption} />;
  };

  const getCaptionMoreSuffix = (): ReactElement | null => {
    if (!isCaptionTruncated) {
      return null;
    }

    return <Text className={`${styles.verticalVideoCaptionMore} ${moreClassName}`} size={TextSize.XS} val={window.i18next.t('pmwjs_more')} />;
  };

  if (caption === '') {
    return null;
  }

  return (
    <div className={styles.verticalVideoCaptionLine}>
      {getCaptionText()}
      {getCaptionMoreSuffix()}
    </div>
  );
}
